// extracted by mini-css-extract-plugin
export default {"header":"StickyHeader_header__4hCF9"};